import script from "./login_SJ.vue?vue&type=script&setup=true&lang=js"
export * from "./login_SJ.vue?vue&type=script&setup=true&lang=js"

import "./login_SJ.vue?vue&type=style&index=0&id=3213ec88&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3213ec88"]])

export default __exports__